module.exports = __webpack_public_path__ + "img/1791982297605.20f8f9f5.png";